// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5c9fd14c","239":"d9baff89","311":"d7f16588","455":"3249a710","595":"bd510925","634":"46e198f1","762":"ad677f2b"}[chunkId] + ".chunk.js";
};